module.exports = __webpack_public_path__ + "img/partner_kxy_01@2x.90922356.png";